import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/form-fields/form-fields.module';
import { OrgsSharedModule } from '@app/orgs/orgs-shared.module';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { UserContentModule } from '@app/user-content/user-content.module';
import { FeedVideoModalComponent } from './components/feed-video-modal/feed-video-modal.component';
import { LearnerHomeFocusSkillsComponent } from './components/learner-home-focus-skills/learner-home-focus-skills.component';
import { QuickAddFocusSkillPopoverComponent } from './components/learner-home-focus-skills/quick-add-focus-skill-popover/quick-add-focus-skill-popover.component';
import { LearnerHomeResourcesComponent } from './components/learner-home-resources/learner-home-resources.component';
import { LearnerHomeComponent } from './components/learner-home/learner-home.component';
import { MonthlyActivityComponent } from './components/monthly-activity/monthly-activity.component';
import { QuickLinksComponent } from './components/quick-links/quick-links.component';
import { SuggestedSectionComponent } from './components/suggested-section/suggested-section.component';
import { UserSummaryComponent } from './components/user-summary/user-summary.component';
import { LeanerHomeRoutingModule } from './learner-home-routing.module';
import { LearnerHomeFocusSkillsService } from './services/learner-home-focus-skills.service';
import { MonthlyActivityService } from './services/monthly-activity.service';
import { SuggestedResourcesService } from './services/suggested-resources.service';
import { UserSummaryService } from './services/user-summary.service';
import { RecommendationInfoPipe } from './pipes/recommendation-info.pipe';
import { LearnerHomeDiscoverComponent } from './components/learner-home-discover/learner-home-discover.component';
import { ProfileModule } from '@app/profile/profile.module';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { ResourceLauncherModule } from '@app/resource-launcher/resource-launcher.module';
import { MentoringModule } from '@app/mentoring/mentoring.module';
import { OpportunitiesModalsModule } from '@app/opportunities/opportunities-modals.module';
import { OpportunitiesSharedModule } from '@app/opportunities/opportunities-shared.module';
import { PathwayPageModule } from '@app/pathways/components/page/pathway-page.module';
import { LearnerHomeBudgetComponent } from './components/learner-home-budget/learner-home-budget.component';

@NgModule({
  declarations: [
    LearnerHomeComponent,
    LearnerHomeFocusSkillsComponent,
    LearnerHomeResourcesComponent,
    MonthlyActivityComponent,
    QuickLinksComponent,
    SuggestedSectionComponent,
    UserSummaryComponent,
    QuickAddFocusSkillPopoverComponent,
    FeedVideoModalComponent,
    RecommendationInfoPipe,
    LearnerHomeDiscoverComponent,
    LearnerHomeBudgetComponent,
  ],
  providers: [
    LearnerHomeFocusSkillsService,
    MonthlyActivityService,
    SuggestedResourcesService,
    UserSummaryService,
    RecommendationInfoPipe,
  ],
  imports: [
    CommonModule,
    SharedModule,
    OrgsSharedModule,
    TagsModule,
    FormFieldsModule,
    UserContentModule,
    RouterModule,
    LeanerHomeRoutingModule,
    ProfileModule, // TODO: Lazyloaded module - needs refactor
    GroupsSharedModule,
    ResourceLauncherModule,
    MentoringModule, // Currently being loaded *by* ProfileModule, needed for mentoring card actions
    OpportunitiesModalsModule, // For opportunity modals opened by opportunity cards.
    OpportunitiesSharedModule, // This is *eventually* where opportunity cards will be.
    PathwayPageModule, // TODO: Lazyloaded module - needs refactor
  ],
  exports: [LearnerHomeDiscoverComponent],
})
export class LearnerHomeModule {}
